<template>
  <div>
    <form-navigation-tabs
      :tabs="tabs"
      v-on:selected="setActive"
      :active="currentView"
      class="margin-t-10"
      :enable-logging="true"
      :incident="incident"
      :module="module"
      :parentTabs="['Client']"
    ></form-navigation-tabs>

    <client-details
      :incident="incident"
      :readonly="readonly"
      v-if="currentView == 'details'"
      v-on:unsaved-data="saveStatus"
    ></client-details>

    <client-vehicle
      :incident="incident"
      :readonly="readonly"
      v-if="currentView == 'vehicle'"
      v-on:unsaved-data="saveStatus"
    ></client-vehicle>

    <client-indemnity
      :incident="incident"
      :readonly="readonly"
      v-if="currentView == 'indemnity'"
      v-on:unsaved-data="saveStatus"
    ></client-indemnity>

    <client-insurance
      :incident="incident"
      :readonly="readonly"
      v-if="currentView == 'insurance'"
      v-on:unsaved-data="saveStatus"
    ></client-insurance>

    <occupants
      :incident="incident"
      :readonly="readonly"
      v-if="currentView == 'occupants'"
    ></occupants>
  </div>
</template>
<script>
import ClientDetails from './ClientDetails.vue';
import ClientVehicle from './ClientVehicle.vue';
import ClientInsurance from './ClientInsurance.vue';
import Occupants from './Occupants.vue';
import ClientIndemnity from './ClientIndemnity';

export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    module: {
      type: String,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  components: {
    ClientIndemnity,
    'client-details': ClientDetails,
    'client-vehicle': ClientVehicle,
    'client-insurance': ClientInsurance,
    occupants: Occupants
  },

  data() {
    return {
      currentView: 'details',
      unsaved_data: false,
      tabs: [
        {
          name: 'details',
          label: 'Details',
          disabled: false
        },
        {
          name: 'vehicle',
          label: 'Vehicle',
          disabled: false
        },
        {
          name: 'indemnity',
          label: 'Indemnity',
          disabled: false
        },
        {
          name: 'insurance',
          label: 'Insurance',
          disabled: false
        },
        {
          name: 'occupants',
          label: 'Occupants',
          disabled: false
        }
      ]
    };
  },

  methods: {
    saveStatus(value) {
      this.unsaved_data = value;

      this.$emit('unsaved-data', value);
    },

    setActive(tab) {
      // check if unsaved data on the current form
      if (this.unsaved_data && this.currentView !== tab) {
        this.saveWarning(tab); // show alert if there is
      } else {
        this.currentView = tab;
      }
    },

    saveWarning(tab) {
      window
        .swal({
          title: 'Are you sure?',
          text:
            'You will lose all details entered in this section if you continue!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Continue without saving',
          cancelButtonText: 'Cancel and stay in this section'
        })
        .then(
          () => {
            // Go to selected tab discarding changes
            this.currentView = tab;
            this.unsaved_data = false;
          },
          dismiss => {}
        );
    }
  }
};
</script>
